import styled from "styled-components/native";
import {
  HeaderBackButtonProps,
  HeaderButtonProps,
} from "@react-navigation/elements";
import React from "react";
import PressableOpacity from "@app/components/questkit/PressableOpacity";

export const HeaderIcon = styled(PressableOpacity)<{ $transparent?: boolean }>`
  margin-horizontal: 16px;
  width: 38px;
  height: 38px;
  border-radius: 19px;
  background-color: ${({ theme, $transparent }) =>
    $transparent ? "transparent" : theme.background};
  justify-content: center;
  align-items: center;
`;

export const PlaceholderHeaderIcon: React.FC<
  HeaderButtonProps | HeaderBackButtonProps
> = () => {
  return <EmptyView />;
};

const EmptyView = styled.View`
  width: 40px;
  height: 40px;
`;
